/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2019, Zumper
 * @description Photo Carousel Left Chevron Component
 */

import { IconProps } from '../../types'

export const ChevronLeft = ({ fill = '#0a0f1c', size = 10, ...rest }: IconProps) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 37 37"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M18.6748 34.6401L2.00001 17.9653L17.9652 2.00009"
        stroke={fill}
        strokeLinecap="round"
        strokeWidth="5"
      />
    </svg>
  )
}
